import {Transaction} from "../../data/data-class/transaction/transactionClass";
import ViaqTryCatch from "../../services/GlobalTryCatch";
import axiosInstance from "../../services/axios";

class TransactionRepository {
    static async gettransaction(text, pagenumber, numberFilter, datefilter) {
        // let {text, pagenumber, numberFilter, datefilter} = data_;
        console.log("TEXT : ")

        function eArabic(x) {
            return x.toLocaleString("fa-IR");
        }

        const data = {
            text: text.trim(),
            pageNumber: pagenumber,
            number: datefilter,
            priceORaction: numberFilter,
        };
        // const TransAction = await postRequestWithToken("/transaction", data);
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/transaction", data)
            });
        // const url=TransAction.url
        const code = response.statusCode;
        const message = response.message;
        let transObject = null
        let chartdata = undefined
        let counAll = 0
        if (response.success) {
            transObject = response.data.Transaction.map((transaction) => {
                return new Transaction(
                    transaction.number ? transaction.number : "ندارد",
                    transaction.userFullName,
                    transaction.status,
                    transaction.amount ? eArabic(transaction.amount) : "ندارد",
                    transaction.date,
                    transaction.cardNum ? transaction.cardNum : "ندارد",
                    transaction.description ? transaction.description : "ندارد"
                );
            });
            counAll = response.data.countAll;
            chartdata = response.data.dataChart;
        }


        return {
            transactionList: transObject,
            countAllPages: counAll,
            dataChart: chartdata,
            success: response.success,
            code,
            message,
        };
    }

    static async exportt(event) {
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/transaction/export", event)
            });
        let ur = undefined
        if (response.statusCode) {
            ur = TransAction.data;
        }
        return {
            code: response.statusCode,
            message: response.message,
            url: ur,
        };
    }

    static async fileexport(datevaluesstart, datevaluesend) {
        const data = {start: datevaluesstart, end: datevaluesend};
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/transaction/validate", data)
            });

        return {
            code: response.statusCode,
            message: response.message,
        };
    }

    static async generateFactor(id) {
        const data = {id: id};

        return await ViaqTryCatch(
            function () {
                return axiosInstance.post("/transaction/factor", data)
            });


    }

}


export {TransactionRepository};
